import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback } from 'recoil'

import { Flex, LINK_VARIANT_DEFAULT, Link } from 'mailup-web-components'

import IconColumns from 'Components/icons/IconColumns'

import { panelConfigColumnsOpenCallback } from 'Pages/RecipientsList/recoil/callbacks/configColumns'

const ActionChangeColumns: FC = () => {
  const intl = useIntl()

  //  const handleClick = useRecoilCallback(modalConfigColumnsOpenCallback, [])

  const handleConfig = useRecoilCallback(panelConfigColumnsOpenCallback, [])

  return (
    <Link
      variant={LINK_VARIANT_DEFAULT}
      data-mu-test="recipients-open-columns-settings"
      onClick={handleConfig}
    >
      <Flex alignItems="center" gap="8px">
        <IconColumns width="23" />
        <span>
          {intl.formatMessage({
            id: 'Load.RecipientsList.OpenColumnsSettings',
          })}
        </span>
      </Flex>
    </Link>
  )
}

export default ActionChangeColumns
